import { useState } from 'react'

import { metricsDimensionTabs } from '@/metrics/constants'
import {
  getCountriesColumns,
  getCountriesDescription,
} from '@/metrics/pages/DashboardPage/ReturnsMetricsContent/CountriesMetricsCards/helpers'

const useCountriesTabs = ({ salesOrdersDataActivated }) => {
  const [selectedTab, setSelectedTab] = useState(metricsDimensionTabs.product)

  return {
    selectedTab,
    setSelectedTab,
    columns: getCountriesColumns(selectedTab, salesOrdersDataActivated),
    description: getCountriesDescription(selectedTab, salesOrdersDataActivated),
  }
}

export default useCountriesTabs
